export default "__VITE_ASSET__041032bd__"